export class TripStatuses {
  public static REQUESTED = 'REQUESTED'
  public static DISPATCH_ASSIGNED_DRIVER = 'DISPATCH_ASSIGNED_DRIVER'
  public static ACCEPTED = 'ACCEPTED'
  public static NO_RESPONSE_OPERATOR = 'NO_RESPONSE_OPERATOR'
  public static NO_SHOW_RIDER = 'NO_SHOW_RIDER'
  public static TO_PICK_UP = 'DRIVING_TO_PICK_UP'
  public static AT_PICK_UP = 'ARRIVED_AT_PICK_UP'
  public static PICKED_UP = 'PICKED_UP'
  public static TO_DROP_OFF = 'DRIVING_TO_DROP_OFF'
  public static AT_DROP_OFF = 'ARRIVED_AT_DROP_OFF'
  public static DROPPED_OFF = 'DROPPED_OFF'
  public static COMPLETED = 'COMPLETED'
  public static MANUALLY_COMPLETED = 'MANUALLY_COMPLETED'
  public static COMPLETED_PENDING_PAYMENT = 'COMPLETED_PENDING_PAYMENT'
  public static CANCELLED = 'CANCELLED'
  public static DRIVER_CANCELLED = 'DRIVER_CANCELLED'
  public static RIDER_CANCELLED = 'RIDER_CANCELLED'
  public static CANCEL_BILLABLE = 'CANCEL_BILLABLE'
  public static REJECTED = 'REJECTED'
  public static BOOKING_FAILED = 'BOOKING_FAILED'
  public static INTEGRATION_FAILED = 'INTEGRATION_FAILED'
  public static SCHEDULED = 'SCHEDULED'
  public static SCHEDULE_REQUESTED = 'SCHEDULE_REQUESTED'
  public static SCHEDULE_ACCEPTED = 'SCHEDULE_ACCEPTED'
  public static WAITING = 'WAITING'
  public static PENDING = 'PENDING'
  public static WILL_CALL = 'WILL_CALL'
  public static EXPIRED = 'EXPIRED'
}

export class TripStages {
  public static requesting = 'REQUESTING'

  public static waitingForPickUp = 'WAITING_FOR_PICKUP'

  public static enRoute = 'EN_ROUTE'

  public static completed = 'PROCESSED'
}

export type TripStage = typeof TripStages.requesting | typeof TripStages.waitingForPickUp | typeof TripStages.enRoute

export const activeTripStatuses = [
  TripStatuses.WAITING,
  TripStatuses.REQUESTED,
  TripStatuses.ACCEPTED,
  TripStatuses.TO_PICK_UP,
  TripStatuses.AT_PICK_UP,
  TripStatuses.PICKED_UP,
  TripStatuses.TO_DROP_OFF,
  TripStatuses.AT_DROP_OFF
]

export const activeTripStatusesWithDriver = [
  TripStatuses.ACCEPTED,
  TripStatuses.TO_PICK_UP,
  TripStatuses.AT_PICK_UP,
  TripStatuses.PICKED_UP,
  TripStatuses.TO_DROP_OFF,
  TripStatuses.AT_DROP_OFF
]

export const onDemandNoDriver = [TripStatuses.WAITING, TripStatuses.REQUESTED]

export const willCallTripStatuses = [TripStatuses.WILL_CALL]
export const expiredTripsStatusesDashboard = [TripStatuses.EXPIRED]

export const scheduledTripStatuses = [
  TripStatuses.SCHEDULED
  // TripStatuses.SCHEDULE_REQUESTED,
  // TripStatuses.SCHEDULE_ACCEPTED,
  // TripStatuses.WAITING
]

export const issuesTripStatuses = [
  TripStatuses.EXPIRED,
  TripStatuses.NO_RESPONSE_OPERATOR,
  TripStatuses.NO_SHOW_RIDER,
  'stuck',
  TripStatuses.BOOKING_FAILED,
  TripStatuses.INTEGRATION_FAILED,
  TripStatuses.REJECTED
]

export const requestingTripStatuses = [TripStatuses.REQUESTED]
export const waitingForPickupTripStatuses = [TripStatuses.ACCEPTED, TripStatuses.TO_PICK_UP, TripStatuses.AT_PICK_UP]
export const enRouteTripStatuses = [TripStatuses.PICKED_UP, TripStatuses.TO_DROP_OFF, TripStatuses.AT_DROP_OFF]
export const completedTripStatuses = [TripStatuses.COMPLETED, TripStatuses.CANCELLED, TripStatuses.REJECTED]
export const completedTripStatusesDashboard = [
  TripStatuses.COMPLETED,
  TripStatuses.MANUALLY_COMPLETED,
  TripStatuses.COMPLETED_PENDING_PAYMENT
]
export const unsassignedTripStatusesDashboard = [
  TripStatuses.WAITING,
  TripStatuses.SCHEDULE_REQUESTED,
  TripStatuses.REQUESTED,
  TripStatuses.DISPATCH_ASSIGNED_DRIVER,
  TripStatuses.NO_RESPONSE_OPERATOR
]
export const cancelledTripsStatusesDashboard = [
  TripStatuses.CANCELLED,
  TripStatuses.CANCEL_BILLABLE,
  TripStatuses.DRIVER_CANCELLED,
  TripStatuses.RIDER_CANCELLED
]
export const incompleteTripStatusesDashboard = [TripStatuses.NO_RESPONSE_OPERATOR, TripStatuses.NO_SHOW_RIDER]
export const alertStatusTripStatusesDashboard = [
  TripStatuses.WAITING,
  TripStatuses.NO_RESPONSE_OPERATOR,
  TripStatuses.DISPATCH_ASSIGNED_DRIVER,
  TripStatuses.REQUESTED,
  TripStatuses.SCHEDULE_REQUESTED
]
export const failedTripStatusesDashboard = [
  TripStatuses.BOOKING_FAILED,
  TripStatuses.INTEGRATION_FAILED,
  TripStatuses.REJECTED
]
export const operatorAllowedTripStatuses = [
  TripStatuses.TO_PICK_UP,
  TripStatuses.AT_PICK_UP,
  TripStatuses.PICKED_UP,
  TripStatuses.TO_DROP_OFF,
  TripStatuses.AT_DROP_OFF,
  TripStatuses.COMPLETED
]
export const allowNoShowButtonStatuses = [
  TripStatuses.ACCEPTED,
  TripStatuses.SCHEDULE_ACCEPTED,
  TripStatuses.TO_PICK_UP,
  TripStatuses.AT_PICK_UP
]

export const tripIndicatorReloadStatuses = [
  TripStatuses.ACCEPTED,
  TripStatuses.SCHEDULE_ACCEPTED,
  TripStatuses.SCHEDULED,
  TripStatuses.MANUALLY_COMPLETED,
  ...cancelledTripsStatusesDashboard,
  ...incompleteTripStatusesDashboard,
  ...failedTripStatusesDashboard
]

const getStageByStatusStrategy = [
  {
    stage: TripStages.requesting,
    toFindByStatus: (status: string): boolean => requestingTripStatuses.some(it => it === status)
  },
  {
    stage: TripStages.waitingForPickUp,
    toFindByStatus: (status: string): boolean => waitingForPickupTripStatuses.some(it => it === status)
  },
  {
    stage: TripStages.enRoute,
    toFindByStatus: (status: string): boolean => enRouteTripStatuses.some(it => it === status)
  },
  {
    stage: TripStages.completed,
    toFindByStatus: (status: string): boolean => completedTripStatuses.some(it => it === status)
  }
]

export const getStageByStatus = (status: string): string => {
  const stageStrategyResult = getStageByStatusStrategy.find(it => it.toFindByStatus(status))
  return (stageStrategyResult && stageStrategyResult.stage) || 'UNSUPPORTED'
}

type TripStatusValues = Extract<
  { [K in keyof typeof TripStatuses]: (typeof TripStatuses)[K] }[keyof typeof TripStatuses],
  string
>

type TPortalTripStatusLabelAndColor = {
  [K in TripStatusValues]: {
    label: string
    color: string
  }
}

export const PORTAL_TRIP_STATUS_LABEL_AND_COLOR: TPortalTripStatusLabelAndColor = {
  [TripStatuses.REQUESTED]: {
    label: 'REQUESTED',
    color: 'pastel-blue'
  },
  [TripStatuses.DISPATCH_ASSIGNED_DRIVER]: {
    label: 'DISPATCH ASSIGNED DRIVER',
    color: 'pastel-blue' //'pastel-violet'
  },
  [TripStatuses.ACCEPTED]: {
    label: 'ACCEPTED',
    color: 'pastel-green'
  },
  [TripStatuses.NO_RESPONSE_OPERATOR]: {
    label: 'OPERATOR NO RESPONSE',
    color: 'pastel-red'
  },
  [TripStatuses.NO_SHOW_RIDER]: {
    label: 'NO SHOW RIDER',
    color: 'pastel-red'
  },
  [TripStatuses.TO_PICK_UP]: {
    label: 'DRIVER EN ROUTE TO PICK-UP',
    color: 'pastel-blue' //'pastel-light-blue'
  },
  [TripStatuses.AT_PICK_UP]: {
    label: 'DRIVER ARRIVED AT PICK-UP',
    color: 'pastel-blue' //'pastel-light-blue'
  },
  [TripStatuses.PICKED_UP]: {
    label: 'RIDER PICKED UP',
    color: 'pastel-green' //'pastel-soft-green'
  },
  [TripStatuses.TO_DROP_OFF]: {
    label: 'EN ROUTE TO DROP-OFF',
    color: 'pastel-blue' //'pastel-light-blue'
  },
  [TripStatuses.AT_DROP_OFF]: {
    label: 'ARRIVED AT DROP-OFF',
    color: 'pastel-blue' //'pastel-light-blue'
  },
  [TripStatuses.DROPPED_OFF]: {
    label: 'RIDER DROPPED OFF',
    color: 'pastel-green' //'pastel-soft-green'
  },
  [TripStatuses.COMPLETED]: {
    label: 'TRIP COMPLETED',
    color: 'pastel-green' //'pastel-lime'
  },
  [TripStatuses.MANUALLY_COMPLETED]: {
    label: 'TRIP MANUALLY COMPLETED',
    color: 'pastel-green' //'pastel-lime'
  },
  [TripStatuses.COMPLETED_PENDING_PAYMENT]: {
    label: 'COMPLETED - PENDING PAYMENT',
    color: 'pastel-orange'
  },
  [TripStatuses.CANCELLED]: {
    label: 'TRIP CANCELLED',
    color: 'pastel-gray'
  },
  [TripStatuses.DRIVER_CANCELLED]: {
    label: 'CANCELLED BY DRIVER',
    color: 'pastel-gray'
  },
  [TripStatuses.RIDER_CANCELLED]: {
    label: 'CANCELLED BY RIDER',
    color: 'pastel-gray'
  },
  [TripStatuses.CANCEL_BILLABLE]: {
    label: 'BILLABLE CANCELLATION',
    color: 'pastel-orange' //'pastel-pink'
  },
  [TripStatuses.REJECTED]: {
    label: 'TRIP REJECTED',
    color: 'pastel-red' //'pastel-pink'
  },
  [TripStatuses.BOOKING_FAILED]: {
    label: 'BOOKING FAILED',
    color: 'pastel-red' //'pastel-pink'
  },
  [TripStatuses.INTEGRATION_FAILED]: {
    label: 'INTEGRATION FAILED',
    color: 'pastel-red' //'pastel-pink'
  },
  [TripStatuses.SCHEDULED]: {
    label: 'SCHEDULED',
    color: 'pastel-blue' //'pastel-mint'
  },
  [TripStatuses.SCHEDULE_REQUESTED]: {
    label: 'SCHEDULE REQUESTED',
    color: 'pastel-blue' //'pastel-mint'
  },
  [TripStatuses.SCHEDULE_ACCEPTED]: {
    label: 'SCHEDULE ACCEPTED',
    color: 'pastel-blue' //'pastel-mint'
  },
  [TripStatuses.WAITING]: {
    label: 'WAITING FOR DRIVER',
    color: 'pastel-orange' //'pastel-yellow'
  },
  [TripStatuses.PENDING]: {
    label: 'PENDING',
    color: 'pastel-orange' //'pastel-purple'
  },
  [TripStatuses.WILL_CALL]: {
    label: 'WILL CALL BACK',
    color: 'pastel-orange' //'pastel-purple'
  },
  [TripStatuses.EXPIRED]: {
    label: 'TRIP EXPIRED',
    color: 'pastel-red' //'pastel-purple'
  }
}



// WEBPACK FOOTER //
// ./src/constants/trip-statuses.ts